import React from "react";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import FormIndicator from "../FormIndicator";
import FixtureBetButton from "../FixtureBetButton";
import StatsDisplay from "../StatsDisplay";
import {
  Container,
  CompetitionName,
  TeamsRow,
  TeamContainer,
  RightContainer,
  CompetitionNameContainer,
  TeamSeparator,
} from "./styles";
import {
  Contestant,
  Form,
  StatsType,
  Selections,
  Meta,
} from "../../../../types/fixture";
import FixtureWarning from "../FixtureWarning";

dayjs.extend(utc);
dayjs.extend(timezone);

interface Props {
  contestant: Contestant[];
  date: string;
  selections: Selections[];
  form: Form;
  marketName: string;
  stats: StatsType[];
  meta: Meta;
}

function MatchCard({
  contestant,
  date,
  selections,
  form,
  marketName,
  stats,
  meta,
}: Props): JSX.Element {
  const homeTeam = contestant.find((team) => team.position === "home");
  const awayTeam = contestant.find((team) => team.position === "away");

  const renderTeamRow = (team: Contestant): JSX.Element => {
    if (team.position === "away")
      return (
        <>
          <TeamsRow key={team.id}>
            <TeamContainer>
              <img
                src={`https://cdn.checkd-dev.com/bettinghub/teams/${team.id}.png`}
                alt={team.name}
                loading="lazy"
              />
              <p>{team.name}</p>
            </TeamContainer>
            <RightContainer>
              <FormIndicator form={form.away} />
            </RightContainer>
          </TeamsRow>
          <TeamSeparator>
            @
            <hr />
          </TeamSeparator>
        </>
      );
    return (
      <TeamsRow key={team.id} addMarginBottom>
        <TeamContainer>
          <img
            src={`https://cdn.checkd-dev.com/bettinghub/teams/${team.id}.png`}
            alt={team.name}
            loading="lazy"
          />
          <p>{team.name}</p>
        </TeamContainer>
        <RightContainer>
          <FormIndicator form={form.home} />
        </RightContainer>
      </TeamsRow>
    );
  };

  const homeStats = stats.find((stat) => stat.type === "home");
  const awayStats = stats.find((stat) => stat.type === "away");
  const homeTeamTotal = homeStats?.total;
  const awayTeamTotal = awayStats?.total;

  return (
    <Container>
      <CompetitionNameContainer>
        <CompetitionName>
          {meta.competition.id} •{" "}
          <span className="time">
            {dayjs.utc(date).local().format("ddd D MMM hh:mmA")}
          </span>
        </CompetitionName>
        {homeTeamTotal! <= 3 || awayTeamTotal! <= 3 ? (
          <FixtureWarning stats={stats} eventContestants={contestant} />
        ) : null}
      </CompetitionNameContainer>
      {awayTeam ? renderTeamRow(awayTeam) : null}
      {homeTeam ? renderTeamRow(homeTeam) : null}
      <p className="stats-title">{marketName}</p>
      <StatsDisplay stats={stats} eventContestants={contestant} />
      <hr />
      <FixtureBetButton
        selections={selections}
        market={marketName}
        competition={meta?.competition?.id}
        eventContestants={contestant}
      />
    </Container>
  );
}

export default MatchCard;
